import { render } from "./Error.vue?vue&type=template&id=10406b54"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=10406b54&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/ErrorHandler/Error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10406b54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10406b54', __exports__)) {
    api.reload('10406b54', __exports__)
  }
  
  module.hot.accept("./Error.vue?vue&type=template&id=10406b54", () => {
    api.rerender('10406b54', render)
  })

}


export default __exports__